export function formatCurrency(amount: number): string {
  if (isNaN(amount)) {
    throw new TypeError("Invalid number provided to formatCurrency");
  }
  return `E${Number(amount).toFixed(2)}`;
}
